/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Sales Call Grader API
 * AI-powered sales enablement platform
 * OpenAPI spec version: 2.0.0
 */

/**
 * Hanover meeting types (purpose of a specific call).
 */
export type MeetingType = (typeof MeetingType)[keyof typeof MeetingType];

export const MeetingType = {
  Initial_Contact: "Initial Contact",
  Discovery: "Discovery",
  Advance: "Advance",
  Proposal: "Proposal",
  Close: "Close",
} as const;
